<span id="{{id}}" class="deal-status {{statusClass}}">{{statusText}}{{suffix}}</span>
